<template>
    <div id="shencunzhuangtai" style="height: 300px; margin:0 auto" v-loading="loading">
    </div>
</template>

<script>
    import echarts from 'echarts'

    export default {
        name: 'shencunzhuangtai',
        props: {
            dataPie: {
                default: []
            },
            colorList:{
                default: []
            }
        },
        data() {
            return {
                loading: false,
                myChart: null
            }
        },
        watch: {
            dataPie: {
                deep: true, // 深度监听，能够监听到对象内部值的变化
                // eslint-disable-next-line no-unused-vars
                handler(newVal, oldVal) {
                    this.drawLine()
                }
            }
        },
        beforeDestroy() {
            if (this.myChart != null) {
                this.myChart.dispose(); // 销毁ECharts实例
            }
            window.removeEventListener('resize', this.handleResize); // 移除事件监听器
        },
        mounted() {
            let that = this
            var username = localStorage.getItem('username')
            if (username != 'demo') {
                that.drawLine()
                window.addEventListener('resize', this.handleResize);
            }
        },
        methods: {
            handleResize() {
                if (this.myChart) {
                    this.myChart.resize(); // 调用resize方法调整图表大小
                }
            },
            drawLine() {
                this.loading = true
                window.addEventListener('resize', this.handleResize);
                this.myChart = echarts.init(document.getElementById('shencunzhuangtai'))
                let option = {
                    color: this.colorList,
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        // orient: 'vertical',
                        bottom: 'bottom',
                        // top: 'middle'
                    },
                    series: [
                        {
                            name: '病例分类数量',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '40%'],
                            data: this.dataPie,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            label: {
                                normal: {
                                    formatter: params => {
                                        return (
                                            '{name|' + params.name + '}{value|' + params.value + '}'
                                        );
                                    },
                                    rich: {
                                        name: {
                                            fontSize: 13,
                                            padding: [0, 0, 0, 5],
                                        },
                                        value: {
                                            fontSize: 13,
                                            padding: [0, 0, 0, 5],
                                        }
                                    }
                                }
                            },
                        }
                    ]
                }
                this.myChart.setOption(option)
                this.loading = false
                // 添加点击事件监听
                this.myChart.on('click', this.onChartClick);
            },
            onChartClick(params) {
                // params 包含点击事件的信息，如数据名称、数据值等
                if(params.name.indexOf("存活(已随访)")>-1){
                    params.name = "存活，已随访"
                }
                this.$router.push({ path: '/rms/archives', query: { name: params.name } });
                // alert('点击了 ' + params.name + '，值为：' + params.value);
            }
        }
    };
</script>
